import { render, staticRenderFns } from "./PFrom.vue?vue&type=template&id=4ff376cc&scoped=true"
import script from "./PFrom.vue?vue&type=script&lang=js"
export * from "./PFrom.vue?vue&type=script&lang=js"
import style0 from "./PFrom.vue?vue&type=style&index=0&id=4ff376cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff376cc",
  null
  
)

export default component.exports